// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getQuotes } from "@ces/App/Services/QuoteService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { GetQuotesApiParameter } from "@insite/client-framework/Services/QuoteService";
import { QuoteCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<GetQuotesApiParameter, QuoteCollectionModel>;

export const DispatchBeginLoadQuotes: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomQuotes/BeginLoadQuotes",
        parameter: props.parameter,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getQuotes(props.apiParameter);
};

export const DispatchCompleteLoadQuotes: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomQuotes/CompleteLoadQuotes",
        collection: props.apiResult,
        parameter: props.parameter,
    } as any);
};

export const chain = [DispatchBeginLoadQuotes, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadQuotes];

const loadCustomQuotes = createHandlerChainRunner(chain, "loadCustomQuotes");
export default loadCustomQuotes;
